import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Typography as CoreTypography, Fonts as CoreFonts } from '@vds-core/typography';
import { Fonts } from '../../fonts';
import { TypographyConfig } from '../../index';

var Typography = function Typography(props) {
  // load fonts here if needed

  /* istanbul ignore next */
  if (Fonts.checkFontLoaded && !Fonts.checkFontLoaded()) {
    Fonts.loadFonts && Fonts.loadFonts();
    CoreFonts && CoreFonts.setFontsLoaded && CoreFonts.setFontsLoaded(true);
  }

  return /*#__PURE__*/React.createElement(CoreTypography, _extends({}, props, {
    typescale: TypographyConfig.getTypescale(),
    fontsconfig: Fonts
  }));
};

export default Typography;